import React from "react";
import { useUser } from "src/business-types/grocery/components/UserContext";
import { colorOptions, fontOptions } from "src/shared/modules/profile/theme/themeConstants";

interface ViewOrderButtonProps {
  orderId: string;
  isLoading: boolean;
  onViewOrder: (orderId: string) => void;
}

const ViewOrderButton: React.FC<ViewOrderButtonProps> = ({ orderId, isLoading, onViewOrder }) => {
   const { user } = useUser();
    
    const bgClass = colorOptions[user?.background_colour || "DodgerBlue"];
    const fontClass = fontOptions[user?.font_family || "Sans-serif"];
  return (
    <button className={`view-btn ${bgClass} ${fontClass}`} onClick={() => onViewOrder(orderId)} disabled={isLoading}>
      {isLoading ? "Loading..." : "View"}
    </button>
  );
};

export default ViewOrderButton;
